import * as internal from "./internal/multipart.js";
export const make = internal.make;
export const defaultIsFile = internal.defaultIsFile;
export const decodeField = internal.decodeField;
//# sourceMappingURL=index.js.map